export var SurveyStatus;
(function (SurveyStatus) {
    SurveyStatus["Created"] = "created";
    SurveyStatus["Canceled"] = "canceled";
    SurveyStatus["InProcess"] = "in_process";
    SurveyStatus["Uploading"] = "uploading";
    SurveyStatus["Completed"] = "completed";
    SurveyStatus["SubmissionInProcess"] = "submission_in_process";
    SurveyStatus["SubmissionError"] = "submission_error";
    SurveyStatus["Submitted"] = "submitted";
})(SurveyStatus || (SurveyStatus = {}));
